import React from 'react'
import { color, hexToRgb } from 'styles/colors'
import styled from 'styled-components'

interface TooltipProps {
  color: string
  value: string
  showInTooltip?: boolean
  name: string
}

type Props = {
  left: number,
  top: number,
  tooltipData: Array<TooltipProps>
}

const HoverBox = ({ left, top, tooltipData }: Props) => {
  const [nonPlottedData, plottedData] = tooltipData.reduce(
    (
      [nonPlotted, plotted]: [
        Array<TooltipProps>,
        Array<TooltipProps>
      ],
      data
    ) => {
      if (data.showInTooltip === false) {
        plotted.push(data)
      } else {
        nonPlotted.push(data)
      }
      return [nonPlotted, plotted]
    },
    [[], []]
  )

  return (
    <S.HoverBox left={left} top={top}>
      {nonPlottedData.map((data) => {
        return (
          <S.HoverOnlyMetric key={data.name}>
            <p>{`${data.name}:  ${data.value}`}</p>
          </S.HoverOnlyMetric>
        )
      })}
      {plottedData.map((data) => {
        return (
          <S.Metric key={data.name} color={data.color}>
            <S.Dot bgColor={data.color} />
            {`= ${data.value}`}
          </S.Metric>
        )
      })}
    </S.HoverBox>
  )
}

export default HoverBox

const S = {
  HoverBox: styled.div.withConfig({
    shouldForwardProp: (prop) => !['top', 'left'].includes(prop)
  })<{ top: number, left: number }>`
    position: absolute;
    padding: 5px;
    z-index: 1;
    background-color: ${hexToRgb(color('maintenanceTrendHoverBoxBackground'), 0.7)};
    border: 1px solid ${color('maintenanceTrendHoverBoxBoarder')};
    padding: 5px;
    top: ${({ top }) => top}px;
    left: ${({ left }) => left}px;
    transform: translate(-50%, -100%);
    font-size: 12px;
    font-weight: 700;
    margin: 0 75px;
  `,
  HoverOnlyMetric: styled.div`
    color: ${color('ancillaryText')};
  `,
  Metric: styled.div.withConfig({
    shouldForwardProp: (prop) => !['color'].includes(prop)
  })<{ color: string }>`
    color: ${({ color }) => color}
  `,
  Dot: styled.span.withConfig({
    shouldForwardProp: (prop) => !['bgColor'].includes(prop)
  })<{bgColor?: string}>`
    margin: 0px 5px;
    height: 10px;
    width: 10px;
    border-radius: 50%;
    background-color: ${({ bgColor }) => bgColor};
    display: inline-block;
  `
}
